<section class="child">
    <div c-search-box search-state='case.search'></div>
</section>
<section class="child">
    <nav>
        <c-offline-form-message type="'CaseflowConfig'" is-competency="false"/>
    </nav>
</section>
<section class="child">
    <nav>
        <c-tree-explorer config="shortcutsConfig"></c-tree-explorer>
    </nav>
</section>
